export class EksCluster {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterArn",
            "baseName": "clusterArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterName",
            "baseName": "clusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "endpoint",
            "baseName": "endpoint",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "EksClusterStatus",
            "format": ""
        },
        {
            "name": "kubeAccessStatus",
            "baseName": "kubeAccessStatus",
            "type": "KubeAccessStatus",
            "format": ""
        },
        {
            "name": "kubeAccessStatusMessage",
            "baseName": "kubeAccessStatusMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionEnabled",
            "baseName": "encryptionEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EksCluster.attributeTypeMap;
    }
    constructor() {
    }
}
